// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"a1e4fd2115d1c85e","node_modules_canvg_lib_index_es_js":"254444adc3b37d37"}[chunkId] + ".js";
};